import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
import { Size } from "yfiles";
import { NAMESPACE as PARENT_NAMESPACE } from "../constants";
import DottedBackground from "Common/imgGen/DottedBackground";
export const NAMESPACE = "ontologicalModel";
export const FULL_NAMESPACE = createNamespace(PARENT_NAMESPACE, NAMESPACE);
export { PARENT_NAMESPACE as PAGE_NAMESPACE };
export const NODE_DEFAULT_SIZE = new Size(40, 40);
export const NODE_MAX_SIZE = new Size(290, 40);
export const ZOOM = {
    MIN: 0.1,
    MAX: 2,
    DEFAULT: 0.25,
    NAVIGATE_TO_MAX: 1,
    NAVIGATE_TO_MIN: 0.5
};
const COMMAND_ATTR = "data-graph-command";
export const undoButtonAttrs = { [COMMAND_ATTR]: "Undo" };
export const redoButtonAttrs = { [COMMAND_ATTR]: "Redo" };
export const undoSelector = `[${COMMAND_ATTR}='Undo']`;
export const redoSelector = `[${COMMAND_ATTR}='Redo']`;
export const GRAPH_IN_PROGRESS_CLASS_NAME = "graph-in-progress";
export const UNDO_ENGINE_AUTO_MERGE_TIME = 300;
export const DETAILS_THRESHOLD_ZOOM_LEVEL = 0.65;
export const INTERMEDIATE_THRESHOLD_ZOOM_LEVEL = 0.4;
export const localStorageSettingsKey = "ohotnik.ontologicalModel.rightSideDetailsPanel.settings";
export const NEW_DOCUMENT_OBJECT_ATTRIBUTE = {
    Id: "",
    Key: "",
    Name: "",
    Type: undefined,
    DocumentObjectId: undefined,
    Description: "",
    Mandatory: false,
    Label: false,
    Position: 0,
    MaximumLengthChars: 0
};
export const documentObjectAttributeRequiredFields = ["Key", "Name", "Type"];
export const NEW_DOCUMENT_OBJECT = {
    Id: "",
    Name: "",
    GroupName: "",
    GroupId: null,
    Attributes: [],
    Color: "",
    Icon: "",
    Description: ""
};
export const documentObjectRequiredFields = ["Name"];
export const DOCUMENT_OBJECT_ID_PREFIX_CORE = "ET";
export const DOCUMENT_OBJECT_ATTRIBUTE_ID_PREFIX_CORE = "PT";
export const ONTOLOGICAL_MODEL_BG = {
    backgroundImage: DottedBackground(),
    backgroundColor: "#e7eeea"
};
